import { TmTableError } from '@/core/error/table/tmTableError'

export class TmTableNotFoundError extends TmTableError {
  public name = 'TmTableNotFoundError'
}
